import axiosInstance from './axiosInstance';
import { tokenService } from './tokenService';

/** What the site's script reports about a browser that came through a tracked email link (an invite's button, a
 * notification or campaign email's link). Nothing here identifies the person. */
export interface BrowserSignals {
  webdriver?: boolean;
  headless?: boolean;
  languages?: string[];
  timezone?: string;
  screen?: string;
  viewport?: string;
  touch_points?: number;
  cores?: number;
  memory_gb?: number;
  plugins?: number;
  visible?: boolean;
  focused?: boolean;
  /** pointer, key, touch or wheel (the first use), or signed_in (reported at once by a signed-in browser), and how
   * long after the page loaded. */
  input?: string;
  after_ms?: number;
}

/**
 * Send a site report. Signed in, it goes with the account, so the server knows whose browser it is; otherwise as a
 * plain-text keepalive request, which needs no preflight and survives the page going to Google.
 */
export async function postSiteReport(path: string, signals: BrowserSignals): Promise<void> {
  if (tokenService.hasToken()) {
    await axiosInstance.post(path, signals);

    return;
  }
  await fetch(`${axiosInstance.defaults.baseURL || ''}${path}`, {
    method: 'POST',
    body: JSON.stringify(signals),
    headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
    credentials: 'omit',
    keepalive: true,
  });
}
